import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useEffect, useState } from 'react';
import CookieBannerComponent from './CookieBannerComponent';
import { useSetCookieConsent, useSiteIdentifier } from './CookieConsentContext';
import { COOKIE_CATEGORIES, getConsentData } from './localStorageUtils';
const CookieBanner = ({ testID = 'cookie-banner', bannerType, hidePrivacyPolicyLink = false }) => {
    const [showBanner, setShowBanner] = useState(false);
    const siteIdentifier = useSiteIdentifier();
    useEffect(() => {
        if (!getConsentData(siteIdentifier)) {
            setShowBanner(true);
        }
    }, [setShowBanner, siteIdentifier]);
    const setCookieConsent = useSetCookieConsent();
    const onAcceptAll = () => {
        // convert COOKIE_CATEGORIES array to an object where all category keys have the value true.
        const data = {};
        COOKIE_CATEGORIES.forEach((category) => {
            data[category] = true;
        });
        setCookieConsent(data);
    };
    const onAcceptEssential = () => {
        // convert COOKIE_CATEGORIES array to an object where all category keys have the value false.
        const data = {};
        COOKIE_CATEGORIES.forEach((category) => {
            data[category] = false;
        });
        setCookieConsent(data);
    };
    return showBanner ? (_jsx("div", Object.assign({ role: "region" }, { children: _jsx(CookieBannerComponent, { onAcceptEssential: onAcceptEssential, onAcceptAll: onAcceptAll, testID: testID, bannerType: bannerType, hidePrivacyPolicyLink: hidePrivacyPolicyLink }) }))) : null;
};
export default CookieBanner;
//# sourceMappingURL=CookieBanner.js.map